import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5a35ea4c&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=5a35ea4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35ea4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a35ea4c')) {
      api.createRecord('5a35ea4c', component.options)
    } else {
      api.reload('5a35ea4c', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5a35ea4c&scoped=true", function () {
      api.rerender('5a35ea4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/csg-return/view.vue"
export default component.exports